export enum LoyaltyType {
  discountFirstPurchase = 'WelcomeDiscountForFirstPurchase',
  discountSecondPurchase = 'WelcomeDiscountForSecondPurchase',
}

export const SOLUTION_DISCOUNT_NAME = 'SolutionsDiscount';
